import { BasicImageTypeProps } from '../types';

export const fillerImages: (
  input: BasicImageTypeProps[]
) => [BasicImageTypeProps, BasicImageTypeProps, BasicImageTypeProps] = (input) => [
  input[0] ?? {},
  input[1] ?? {},
  input[2] ?? {},
];
